/* eslint-disable no-restricted-globals */
// This file MUST be imported first in index.js to patch history
// before React Router captures the original pushState/replaceState.
const origPush = window.history.pushState.bind(window.history);
const origReplace = window.history.replaceState.bind(window.history);

window.history.pushState = function (...args) {
  origPush(...args);
  window.dispatchEvent(new Event('pushstate'));
};

window.history.replaceState = function (...args) {
  origReplace(...args);
  window.dispatchEvent(new Event('replacestate'));
};
